import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const PriceTagSC = styled.div `
user-select: none;

display: inline-block;
box-sizing: border-box;

height: 2rem;
margin-left: 0.75rem;

font-size: ${(props) => props.theme.SizeFontButtonContainedPrice};
line-height: ${(props) => props.theme.SizeLineHeightButtonContainedPrice};
font-weight: ${(props) => props.theme.ContentFontWeightButtonContainedPrice};
text-align: right;

will-change: color;
transition: color 0.3s;

&::before {
  content: "${(props) => props.currency}";
}
`;
const PriceTag = (props) => {
    const { currency, price } = props;
    return React.createElement(PriceTagSC, { currency: currency }, price.toFixed(2));
};
PriceTag.propTypes = {
    currency: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired
};
export default PriceTag;
//# sourceMappingURL=PriceTag.js.map